<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.youthCamp')"
    :batch-actions="batchActions"
    resource="youth_camps"
  >
    <template slot="action">
      <bean-import-button
        can='youth_camps.create'
        buttonText="导入"
        tooltipText="导入青训营"
        url="/youth_camps/import"
        loadingToast="导入中...请不要刷新页面"
        :excelTemplateDownloadLink="importExcelTemplateDownloadLink"
      />

      <bean-link :to="{ name: 'commments_youth_camp_experience_comments.index' }">
        <el-button type="primary">查看心得</el-button>
      </bean-link>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/youth_camps.js';
import _ from 'lodash';

@Component
export default class YouthCamps extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'keyword'
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'number',
      'title',
      'note',
      'cover',
      'start_at',
      'end_at',
      'is_top',
      'lecturer',
      'address',
      'views_count',
      'shares_count',
      'applicants_count',
      'price_type_template',
      'share_desc',
      type === 'show' && 'content_type',
      type === 'show' && { key: 'content', renderCell: { component: 'html' }  },
      type === 'show' && { key: 'markdown_content', renderCell: { component: 'richText', props: { type: 'markdown' } }  },
      type === 'show' && 'images',
      'published_at',
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'number',
      'title',
      'note',
      'start_at',
      'end_at',
      'lecturer',
      'address',
      {
        key: 'cover',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 691x370`,
          props: {
            cropper: {
              width: 691,
              height: 295
            }
          }
        }
      },
      'price_type_template_id',
      {
        key: 'share_desc',
        renderCell: {
          hint: this.$t('hint.shareDescLengthHint'),
        }
      },
      'content_type',
      {
        key: 'content',
        renderCell: {
          component: 'editor'
        }
      },
      {
        key: 'markdown_content',
        renderCell: {
          component: 'markdownEditor'
        }
      },
      {
        key: 'images',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750x320`,
          props: {
            limit: 9,
            cropper: {
              width: 750,
              height: 320
            }
          }
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const handlePublish = async (id) => {
      await this.$autoLoading(this.$request.put(`/posts/${id}/published_at_to_time_current`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }
    const handleUnpublish = async (id) => {
      await this.$autoLoading(this.$request.put(`/posts/${id}/published_at_to_nil`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }
    const handleTop = async (id) => {
      await this.$autoLoading(this.$request.put(`/posts/${id}/is_top_to_true`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }
    const handleUntop = async (id) => {
      await this.$autoLoading(this.$request.put(`/posts/${id}/is_top_to_false`));
      this.$message.success(this.$t('operateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'youth_camps.edit', params: { id: row.id } }
        }
      },
      {
        component: 'routeButton',
        props: {
          label: '报名',
          to: { name: 'apply_records.index', query: { target_id_eq: row.id } }
        }
      },
      !row.published_at &&  {
        component: 'confirmButton',
        props: {
          label: this.$t('post.publish'),
          type: 'primary',
          can: 'youth_camps.update'
        },
        on: {
          confirm: () => handlePublish(row.id)
        }
      },
      row.published_at &&  {
        component: 'confirmButton',
        props: {
          label: this.$t('post.unpublish'),
          type: 'primary',
          can: 'youth_camps.update'
        },
        on: {
          confirm: () => handleUnpublish(row.id)
        }
      },
      !row.is_top &&  {
        component: 'confirmButton',
        props: {
          label: '置顶',
          type: 'primary',
          can: 'youth_camps.update'
        },
        on: {
          confirm: () => handleTop(row.id)
        }
      },
      row.is_top &&  {
        component: 'confirmButton',
        props: {
          label: '取消置顶',
          type: 'primary',
          can: 'youth_camps.update'
        },
        on: {
          confirm: () => handleUntop(row.id)
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'youth_camps.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>导出</el-button>
    ];
  }

  get importExcelTemplateDownloadLink() {
    const baseUrl = process.env.BASE_URL;
    const fileName = '导入青训营';
    const url = baseUrl.endsWith('/') ? `${fileName}.xlsx` : `/${fileName}.xlsx`
    return baseUrl + url;
  }
}

export const route = [
  {
    path: '/youth_camps',
    name: 'youth_camps.index',
    component: YouthCamps,
    props: {
      type: 'index',
    }
  },
  {
    path: '/youth_camps/new',
    name: 'youth_camps.new',
    component: YouthCamps,
    props: {
      type: 'new',
    }
  },
  {
    path: '/youth_camps/:id',
    name: 'youth_camps.show',
    component: YouthCamps,
    props: {
      type: 'show',
    }
  },
  {
    path: '/youth_camps/:id/edit',
    name: 'youth_camps.edit',
    component: YouthCamps,
    props: {
      type: 'edit'
    }
  }
]
</script>

<style lang="scss" scoped>
  /deep/ .source-page-form > .page-content > .el-form > .el-form-item {
    &.markdown_content,
    &.content {
      width: 100%;

      .ckeditor-view {
        width: 100%
      }
    }
  }
</style>
